const icon = require('vue-svgicon');
icon.register({
    'check-thin': {
        width: 12,
        height: 12,
        viewBox: '0 0 12 12',
        data: `<path pid="0" d="M11.192 2.847L4.42 9.815c-.01.014-.005.032-.017.044a.466.466 0 01-.351.14.464.464 0 01-.358-.138c-.014-.015-.009-.037-.02-.053L.806 6.861a.505.505 0 010-.7.471.471 0 01.68 0l2.56 2.634 6.464-6.65a.473.473 0 01.681 0 .506.506 0 010 .702z" _fill="#6737AF"/>`,
    },
});
